import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateAxios } from "../axios";
import { propositionsQueryKeys } from "../query-keys/propositions.query-keys";
import { societiesQueryKeys } from "../query-keys/societies.query-keys";
import { contractsKeys } from "../queries/contracts.queries";
import { gfasQueryKeys } from "../query-keys/gfas.query-keys";
import { constructionSitesQueryKeys } from "../query-keys/constructionSites.query-keys";
import { getErrorMessage } from "../../../../../packages/vars/src";

export const attachDocumentToTask = async (
	taskId: number,
	fileId: string,
): Promise<{ message: string }> => {
	const { data } = await privateAxios.post<{ message: string }>(
		`/tasks/${taskId}/files`,
		{ fileId },
	);
	return data;
};

export const useAttachDocumentToTask = (
	propositionId?: number,
	brokerId?: number,
	constructionSiteId?: string,
	contractId?: number,
	gfaId?: string,
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ taskId, fileId }: { taskId: number; fileId: string }) =>
			attachDocumentToTask(taskId, fileId),
		onSuccess: () => {
			if (propositionId) {
				queryClient.invalidateQueries({
					queryKey: propositionsQueryKeys.tasks(propositionId),
					refetchType: "active",
				});
			}
			if (brokerId) {
				queryClient.invalidateQueries({
					queryKey: societiesQueryKeys.brokerTasks(brokerId),
					refetchType: "active",
				});
			}
			if (constructionSiteId) {
				queryClient.invalidateQueries({
					queryKey: constructionSitesQueryKeys.tasks(constructionSiteId),
					refetchType: "active",
				});
			}
			if (contractId) {
				queryClient.invalidateQueries({
					queryKey: contractsKeys.tasks(contractId),
					refetchType: "active",
				});
			}
			if (gfaId) {
				queryClient.invalidateQueries({
					queryKey: gfasQueryKeys.tasks(gfaId),
					refetchType: "active",
				});
			}
			toast.success("Document ajouté à la tâche avec succès");
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de l'ajout du document", {
				description: errorMessage,
			});
		},
	});
};
